import '@shui/core/sh-accordion';

import { Component, input, booleanAttribute, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-accordion',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.arrow-invert]': 'arrowInvert() ? "" : null',
        '[attr.disabled]': 'disabled() ? "" : null',
        '[attr.expanded]': 'expanded() ? "" : null',
        '[attr.flat]': 'flat() ? "" : null',
        '[attr.icon]': 'icon() ?? null',
        '[attr.icon-color]': 'iconColor() ?? null',
        '[attr.info]': 'info() ?? null',
        '[attr.label]': 'label() ?? null',
        '[attr.label-rows]': 'labelRows() ?? null',
        '[attr.no-padding]': 'noPadding() ? "" : null'
    }
})
export class ShAccordionComponent {
    /** If set to `true`, arrow will revert sides and will be positioned at the left. */
    public readonly arrowInvert = input(false, { transform: booleanAttribute });

    /** If set to `true`, the accordion will be disabled. */
    public readonly disabled = input(false, { transform: booleanAttribute });

    /**
     * Defines whether the accordion is open or closed. Can be set to true to be open by default.
     */
    public readonly expanded = input(false, { transform: booleanAttribute });

    /**
     * If set to `true`, the accordion will have no background color nor elevation applied to it.
     */
    public readonly flat = input(false, { transform: booleanAttribute });

    /** Optional property that reflects the icon of the accordion. */
    public readonly icon = input<string | number | undefined>(undefined);

    /** Defines the color of the icon when icon is set. */
    public readonly iconColor = input<string | number | undefined>(undefined);

    /** The info of the accordion that will be shown next to label. */
    public readonly info = input<string | number | undefined>(undefined);

    /** The label of the accordion that will be shown at it's top. Mandatory property. */
    public readonly label = input<string | number | undefined>(undefined);

    /** Allows longer labels to be used. */
    public readonly labelRows = input<string | number | undefined>(undefined);

    /** If set to `true`, the accordion will have no padding applied to it for flat variant. */
    public readonly noPadding = input(false, { transform: booleanAttribute });
}
